import React from 'react'
import { Pivot, PivotItem } from 'office-ui-fabric-react/lib/Pivot'

const SearchSourceTabs = ({selected, handleChange}) =>
  <Pivot selectedKey={selected} onLinkClick={(item) => handleChange(item.props.itemKey, item.props.linkText)}>
    <PivotItem linkText='Website' itemKey='website'>
    </PivotItem>
    <PivotItem linkText='Book' itemKey='book'>
    </PivotItem>
    <PivotItem linkText='Journal' itemKey='article'>
    </PivotItem>
  </Pivot>

  export default SearchSourceTabs



// WEBPACK FOOTER //
// ./src/SearchSourceTabs.js